/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Card3Inputs */

const en_dr_room_card3 = /** @type {(inputs: Dr_Room_Card3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book by chair, not by hour block`)
};

const id_dr_room_card3 = /** @type {(inputs: Dr_Room_Card3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking per kursi, bukan per blok jam`)
};

/**
* | output |
* | --- |
* | "Book by chair, not by hour block" |
*
* @param {Dr_Room_Card3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_card3 = /** @type {((inputs?: Dr_Room_Card3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Card3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_card3(inputs)
	return en_dr_room_card3(inputs)
});